import type { IconProps } from '../types/IconProps.ts';
export const Film: IconProps = {
    name: 'Film',
    children: [
        `<rect width="18" height="18" x="3" y="3" rx="2" />`,
        `<path d="M7 3v18M17 3v18M3 12h18M3 16.5h4M3 7.5h4M17 7.5h4M17 16.5h4" />`,
    ]
};